module.exports = __webpack_public_path__ + "media/images/Moins-3ee83aa1a962f3652d567327413f24ad.svg";